'use client'

import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { UserInfo } from '@/models/user.model'

interface AuthState {
  isLoggedIn: boolean
  userInfo: UserInfo | null
  setUserInfo: (user: UserInfo) => void
  clearUserInfo: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isLoggedIn: false,
      userInfo: null,
      setUserInfo: (user) =>
        set(() => ({
          isLoggedIn: true,
          userInfo: user,
        })),
      clearUserInfo: () =>
        set(() => ({
          isLoggedIn: false,
          userInfo: null,
        })),
    }),
    {
      name: 'auth', // Tên key trong localStorage
      storage: createJSONStorage(() => localStorage), // Tạo custom storage với JSON parsing
      partialize: (state) => ({ isLoggedIn: state.isLoggedIn, userInfo: state.userInfo }), // Lưu trạng thái cần thiết
    }
  )
)
